import { CustomLoaderService } from './../../services/custom-loader.service';
import { ReportService } from './../../services/report.service';
import { FormGroup } from '@angular/forms';
import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-focusedfund',
  templateUrl: './focusedfund.component.html',
  styleUrls: ['./focusedfund.component.scss']
})
export class FocusedfundComponent implements OnInit {
  IsMobile: boolean = false;
  IsSubscribed: boolean = environment.IsSubscribed;
  FocusedForm: FormGroup;
  FocusedSubmitted: boolean = false;
  SelectedAMC: any[] = [];
  FocusingFund: any[] = [];
  FocusedFund: any[] = [];
  constructor(
    private reportservice: ReportService,
    private Loader: CustomLoaderService
  ) {}

  ngOnInit() {
    this.BindAllAMC();
  }
  l() {
    return this.FocusedForm.controls;
  }
  BindAllAMC() {
    this.reportservice.GetTransactionAMCList().subscribe((data) => {
      ////////
      if (data != null) {
        if (
          data.Message != null &&
          data.Message != '' &&
          data.Message.indexOf('Not Authorized') > -1
        ) {
          this.Loader.hide();
          return;
        } else {
          this.SelectedAMC = data.ArrayOfResponse;
        }
      }
    });
  }
}
